<template>
  <v-card class="pa-3">
    <v-card-title>
      {{$t('Please choose languages')}}
    </v-card-title>
    <v-card-text>
      <label  for="">{{$t('Speak language')}}</label>
      <v-select
        v-model="$store.state.core.featuresStatus.speechToTextLang.source"
        :items="langList"
        @change="updateLocalStorage"
        outlined
      />
      <label   for="">{{$t('Translation language')}}</label>
      <v-select
          v-model="$store.state.core.featuresStatus.speechToTextLang.target"
          :items="langList"
          outlined
          @change="updateLocalStorage"
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn outlined color="primary" @click="$emit('closeDialog')">{{$t('Close')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "translationDialog",
  data() {
    return {
      langList: [
        {
          value: 'en',
          text: 'English'
        },
        {
          value: 'ar',
          text: 'العربية'
        }
      ]
    }
  },
  methods: {
    updateLocalStorage() {
      localStorage.setItem('featuresStatus', JSON.stringify(this.$store.state.core.featuresStatus))
    },
  }
}
</script>

<style>
  label {
    display: inline-block;
    padding-bottom: 5px;
  }
</style>
